export default __webpack_public_path__ + "static/media/milton3.390436a9.png";